module.exports = __webpack_public_path__ + "static/media/ill_akne.bbbc41e3.svg";